// @ts-nocheck

class AVPCProductQuiz extends HTMLElement {
  constructor() {
    super();
    this.output = '';
    this.currentSlideIndex = 0;
    this.isTransitioning = false;
    this._heightRafId = null;
  }

  connectedCallback() {
    this.shopDomain = this.dataset.shopDomain || '';
    this.storefrontToken = this.dataset.storefrontToken || '';

    this.quizContainer = this.querySelector('.avpc-pq-quiz-container');
    this.slideElements = Array.from(this.querySelectorAll('.avpc-pq-quiz-slide'));
    this.questionSlideElements = Array.from(
      this.querySelectorAll('.avpc-pq-quiz-slide[data-slide="question"]')
    );
    this.answerInputElements = Array.from(
      this.querySelectorAll('.avpc-pq-answer-option input[type="radio"]')
    );
    this.resultSlideElements = Array.from(
      this.querySelectorAll('.avpc-pq-quiz-slide[data-slide="results"]')
    );
    this.placeholderSlideElement = this.querySelector(
      '.avpc-pq-quiz-slide[data-slide="results-placeholder"]'
    );
    this.emailSlideElement = this.querySelector(
      '.avpc-pq-quiz-slide[data-slide="email-capture"]'
    );
    this.emailFormElement = this.querySelector('[data-email-form]');
    this.emailInputElement = this.querySelector('[data-email-input]');
    this.emailErrorElement = this.querySelector('[data-email-error]');
    this.emailSubmitButton = this.querySelector('[data-email-submit]');
    this.emailSubmitLabel = this.querySelector('[data-submit-label]');

    this.hasRegisteredCustomer = false;
    this.currentRecommendation = null;
    this.mobileMediaQuery = window.matchMedia('(max-width: 800px)');

    this.updateProgressLabels();

    this._boundHandleInputChange = this.handleInputChange.bind(this);
    this._boundHandleViewportChange = this.handleViewportChange.bind(this);
    this._boundHandleAssetLoad = this.handleAssetLoad.bind(this);
    this._boundHandleEmailSubmit = this.handleEmailSubmit.bind(this);

    this.answerInputElements.forEach((inputElement) => {
      inputElement.addEventListener('change', this._boundHandleInputChange);
    });

    if (this.emailFormElement) {
      this.emailFormElement.addEventListener('submit', this._boundHandleEmailSubmit);
    }

    this._boundHandleVariantSelectChange = this.handleVariantSelectChange.bind(this);
    this.querySelectorAll('[data-atc-variant-select]').forEach((selectElement) => {
      selectElement.addEventListener('change', this._boundHandleVariantSelectChange);
    });

    window.addEventListener('resize', this._boundHandleViewportChange);
    window.addEventListener('orientationchange', this._boundHandleViewportChange);
    if (this.mobileMediaQuery.addEventListener) {
      this.mobileMediaQuery.addEventListener('change', this._boundHandleViewportChange);
    } else if (this.mobileMediaQuery.addListener) {
      this.mobileMediaQuery.addListener(this._boundHandleViewportChange);
    }

    this.querySelectorAll('img').forEach((imageElement) => {
      imageElement.addEventListener('load', this._boundHandleAssetLoad);
    });

    if (window.ResizeObserver) {
      this.activeSlideResizeObserver = new ResizeObserver(() => {
        this.scheduleActiveSlideHeightSync();
      });
    }

    this.observeActiveSlide();
    this.scheduleActiveSlideHeightSync();

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-action]');
      if (!button) return;
      const action = button.dataset.action;

      if (action === 'next') this.goToSlide(this.currentSlideIndex + 1);

      if (action === 'continue') {
        this.hideMeaningBox(button.closest('.avpc-pq-quiz-slide'));
        this.advanceAfterAnswer();
      }

      if (action === 'add-to-cart') {
        this.handleAddToCart(button);
      }

      if (action === 'back') {
        const currentSlide = this.slideElements[this.currentSlideIndex];
        const slideType = currentSlide?.dataset.slide;

        if (slideType === 'results' || slideType === 'results-placeholder') {
          // Go back to the email capture step rather than re-answering questions.
          if (this.emailSlideElement) {
            this.goToSlide(this.slideElements.indexOf(this.emailSlideElement));
            return;
          }
        }

        if (slideType === 'email-capture') {
          const lastQuestion = this.questionSlideElements[this.questionSlideElements.length - 1];
          lastQuestion.querySelectorAll('input[type="radio"]').forEach((r) => (r.checked = false));
          this.hideMeaningBox(lastQuestion);
          const lastQuestionIndex = this.slideElements.indexOf(lastQuestion);
          if (lastQuestionIndex >= 0) this.goToSlide(lastQuestionIndex);
          return;
        }

        const targetIndex = this.currentSlideIndex - 1;
        const targetSlide = this.slideElements[targetIndex];
        if (targetSlide) {
          targetSlide.querySelectorAll('input[type="radio"]').forEach((r) => (r.checked = false));
          this.hideMeaningBox(targetSlide);
        }
        this.goToSlide(targetIndex);
      }
    });
  }

  disconnectedCallback() {
    if (this._heightRafId) {
      cancelAnimationFrame(this._heightRafId);
      this._heightRafId = null;
    }

    if (this._boundHandleInputChange && this.answerInputElements) {
      this.answerInputElements.forEach((inputElement) => {
        inputElement.removeEventListener('change', this._boundHandleInputChange);
      });
    }

    if (this.emailFormElement && this._boundHandleEmailSubmit) {
      this.emailFormElement.removeEventListener('submit', this._boundHandleEmailSubmit);
    }

    if (this._boundHandleVariantSelectChange) {
      this.querySelectorAll('[data-atc-variant-select]').forEach((selectElement) => {
        selectElement.removeEventListener('change', this._boundHandleVariantSelectChange);
      });
    }

    if (this._boundHandleAssetLoad) {
      this.querySelectorAll('img').forEach((imageElement) => {
        imageElement.removeEventListener('load', this._boundHandleAssetLoad);
      });
    }

    if (this.activeSlideResizeObserver) {
      this.activeSlideResizeObserver.disconnect();
    }

    if (this._boundHandleViewportChange) {
      window.removeEventListener('resize', this._boundHandleViewportChange);
      window.removeEventListener('orientationchange', this._boundHandleViewportChange);
      if (this.mobileMediaQuery?.removeEventListener) {
        this.mobileMediaQuery.removeEventListener('change', this._boundHandleViewportChange);
      } else if (this.mobileMediaQuery?.removeListener) {
        this.mobileMediaQuery.removeListener(this._boundHandleViewportChange);
      }
    }
  }

  isMobileViewport() {
    return this.mobileMediaQuery ? this.mobileMediaQuery.matches : window.innerWidth <= 800;
  }

  getActiveSlideElement() {
    if (!this.slideElements || !this.slideElements.length) return null;
    return this.slideElements[this.currentSlideIndex] || null;
  }

  observeActiveSlide() {
    if (!this.activeSlideResizeObserver) return;

    this.activeSlideResizeObserver.disconnect();
    const activeSlide = this.getActiveSlideElement();
    if (activeSlide) {
      this.activeSlideResizeObserver.observe(activeSlide);
    }
  }

  scheduleActiveSlideHeightSync() {
    if (this._heightRafId) {
      cancelAnimationFrame(this._heightRafId);
    }

    this._heightRafId = requestAnimationFrame(() => {
      this._heightRafId = null;
      this.syncActiveSlideHeight();
    });
  }

  syncActiveSlideHeight() {
    if (!this.quizContainer) return;

    if (!this.isMobileViewport()) {
      this.quizContainer.style.height = '';
      return;
    }

    const activeSlide = this.getActiveSlideElement();
    if (!activeSlide) return;

    const activeSlideHeight = Math.ceil(activeSlide.offsetHeight);
    if (activeSlideHeight > 0) {
      this.quizContainer.style.height = `${activeSlideHeight}px`;
    }
  }

  handleViewportChange() {
    this.scheduleActiveSlideHeightSync();
  }

  handleAssetLoad() {
    this.scheduleActiveSlideHeightSync();
  }

  updateProgressLabels() {
    const total = this.questionSlideElements.length;
    this.questionSlideElements.forEach((slide, index) => {
      const progressEl = slide.querySelector('[data-progress]');
      if (progressEl) {
        progressEl.textContent = `Step ${index + 1} of ${total}`;
      }
    });
  }

  goToSlide(targetIndex) {
    if (this.isTransitioning) return;
    if (targetIndex < 0 || targetIndex >= this.slideElements.length) return;
    if (targetIndex === this.currentSlideIndex) return;

    this.isTransitioning = true;
    const currentSlide = this.slideElements[this.currentSlideIndex];
    const nextSlide = this.slideElements[targetIndex];

    currentSlide.classList.remove('avpc-pq-active');

    setTimeout(() => {
      nextSlide.classList.add('avpc-pq-active');
      this.currentSlideIndex = targetIndex;
      this.observeActiveSlide();
      this.scheduleActiveSlideHeightSync();
      this.isTransitioning = false;
    }, 400);
  }

  /**
   * Find the meaning box for a given question slide (server-rendered).
   */
  getMeaningBox(slideElement) {
    if (!slideElement) return null;
    return slideElement.querySelector('[data-meaning-box]');
  }

  showMeaningBox(slideElement, html) {
    const box = this.getMeaningBox(slideElement);
    if (!box) return false;

    const textEl = box.querySelector('[data-meaning-text]');
    if (textEl) {
      // html comes from our own server-rendered <template>, populated from
      // the merchant's rich text setting (supports bold + line breaks).
      textEl.innerHTML = html || '';
    }

    // Nothing to show if there's no custom text for this answer.
    if (!html) return false;

    slideElement.classList.add('avpc-pq-showing-meaning');
    box.hidden = false;
    this.scheduleActiveSlideHeightSync();
    return true;
  }

  hideMeaningBox(slideElement) {
    const box = this.getMeaningBox(slideElement);
    if (!box) return;
    box.hidden = true;
    slideElement?.classList.remove('avpc-pq-showing-meaning');
    this.scheduleActiveSlideHeightSync();
  }

  /**
   * Called after a question is answered (and any meaning box dismissed).
   * On the last question, route to the email capture slide instead of
   * straight to results — the result is only revealed once the shopper
   * has registered.
   */
  advanceAfterAnswer() {
    const lastQuestion = this.questionSlideElements[this.questionSlideElements.length - 1];
    const lastQuestionIndex = this.slideElements.indexOf(lastQuestion);

    if (this.currentSlideIndex === lastQuestionIndex) {
      if (this.emailSlideElement) {
        this.goToSlide(this.slideElements.indexOf(this.emailSlideElement));
        if (this.emailInputElement) {
          setTimeout(() => this.emailInputElement.focus(), 450);
        }
      } else {
        this.goToResultSlide(this.currentRecommendation);
      }
    } else {
      this.goToSlide(this.currentSlideIndex + 1);
    }
  }

  goToResultSlide(recommendationNumber) {
    if (recommendationNumber !== null) {
      const matchingSlide = this.resultSlideElements.find(
        (el) => Number(el.dataset.productRecommendation) === recommendationNumber
      );
      if (matchingSlide) {
        this.goToSlide(this.slideElements.indexOf(matchingSlide));
        return;
      }
    }

    // Fall back to placeholder
    if (this.placeholderSlideElement) {
      this.goToSlide(this.slideElements.indexOf(this.placeholderSlideElement));
    }
  }

  getMostSelectedNumber(values) {
    const numberCounts = new Map();

    values
      .flatMap((value) => value.split(','))
      .map((value) => value.trim())
      .filter((value) => value !== '' && !Number.isNaN(Number(value)))
      .forEach((value) => {
        const numericValue = Number(value);
        const currentCount = numberCounts.get(numericValue) || 0;
        numberCounts.set(numericValue, currentCount + 1);
      });

    if (!numberCounts.size) return null;

    let winner = null;
    let winnerCount = -1;

    for (const [number, count] of numberCounts.entries()) {
      if (count > winnerCount || (count === winnerCount && number < winner)) {
        winner = number;
        winnerCount = count;
      }
    }

    return winner;
  }

  updateResultsOutput() {
    this.output = '';

    const selectedValues = Array.from(
      this.querySelectorAll('.avpc-pq-answer-option input[type="radio"]:checked')
    )
      .map((inputElement) => inputElement.value)
      .filter((value) => value !== '');

    this.currentRecommendation = this.getMostSelectedNumber(selectedValues);
  }

  handleInputChange(event) {
    this.updateResultsOutput();

    const inputElement = event.target;
    const slideElement = inputElement.closest('.avpc-pq-quiz-slide');

    // Rich text (bold, line breaks, etc.) is rendered server-side into a
    // hidden <template> so it can carry real markup; we just read its HTML
    // rather than trusting a plain data-* attribute with formatted text.
    const meaningRefId = inputElement.dataset.meaningRef;
    const meaningSource = meaningRefId
      ? slideElement?.querySelector(`#${meaningRefId}`)
      : null;
    const meaningHTML = meaningSource
      ? meaningSource.content.textContent.trim()
        ? meaningSource.innerHTML.trim()
        : ''
      : '';

    // Give the user a moment to see their selection highlight before
    // either showing the meaning box or auto-advancing.
    setTimeout(() => {
      const didShowMeaning = this.showMeaningBox(slideElement, meaningHTML);
      if (!didShowMeaning) {
        this.advanceAfterAnswer();
      }
    }, 200);
  }

  setEmailError(message) {
    if (!this.emailErrorElement) return;
    if (!message) {
      this.emailErrorElement.hidden = true;
      this.emailErrorElement.textContent = '';
    } else {
      this.emailErrorElement.hidden = false;
      this.emailErrorElement.textContent = message;
    }
    this.scheduleActiveSlideHeightSync();
  }

  setEmailSubmitting(isSubmitting) {
    if (this.emailSubmitButton) {
      this.emailSubmitButton.disabled = isSubmitting;
    }
    if (this.emailSubmitLabel) {
      this.emailSubmitLabel.textContent = isSubmitting ? 'Please wait…' : 'See my result';
    }
  }

  isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  async handleEmailSubmit(event) {
    event.preventDefault();

    const email = (this.emailInputElement?.value || '').trim();

    if (!this.isValidEmail(email)) {
      this.setEmailError('Please enter a valid email address.');
      this.emailInputElement?.focus();
      return;
    }

    this.setEmailError('');

    // Already registered this session (e.g. user hit back and re-submitted) —
    // just proceed to the result.
    if (this.hasRegisteredCustomer) {
      this.goToResultSlide(this.currentRecommendation);
      return;
    }

    if (!this.storefrontToken || !this.shopDomain) {
      // Not configured — don't block the shopper from seeing their result,
      // but surface this in the console for the store owner to fix.
      console.warn(
        'AVPC Product Quiz: missing Storefront API token or shop domain; skipping customer registration.'
      );
      this.hasRegisteredCustomer = true;
      this.goToResultSlide(this.currentRecommendation);
      return;
    }

    this.setEmailSubmitting(true);

    try {
      await this.registerCustomer(email);
      this.hasRegisteredCustomer = true;
      this.goToResultSlide(this.currentRecommendation);
    } catch (error) {
      console.error('AVPC Product Quiz: customer registration failed', error);
      // Even on an unexpected error, don't trap the shopper on this slide —
      // still let them see their result.
      this.hasRegisteredCustomer = true;
      this.goToResultSlide(this.currentRecommendation);
    } finally {
      this.setEmailSubmitting(false);
    }
  }

  /**
   * Registers the shopper as a Shopify customer via the public Storefront API.
   * A random password is generated since the shopper never needs to log in
   * with it — this is a lead-capture flow, not an account-creation flow.
   */
  async registerCustomer(email) {
    const endpoint = `https://${this.shopDomain}/api/2024-10/graphql.json`;
    const randomPassword = `Quiz-${Math.random().toString(36).slice(2)}${Date.now()}!`;

    const mutation = `
      mutation customerCreate($input: CustomerCreateInput!) {
        customerCreate(input: $input) {
          customer { id email }
          customerUserErrors { code field message }
        }
      }
    `;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': this.storefrontToken,
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          input: {
            email,
            password: randomPassword,
            acceptsMarketing: true,
          },
        },
      }),
    });

    if (!response.ok) {
      throw new Error(`Storefront API request failed with status ${response.status}`);
    }

    const result = await response.json();
    const userErrors = result?.data?.customerCreate?.customerUserErrors || [];

    if (userErrors.length) {
      // "Email has already been taken" just means they're already a
      // customer — that's fine, treat it as success rather than an error.
      const alreadyExists = userErrors.some((err) => err.code === 'TAKEN');
      if (!alreadyExists) {
        throw new Error(userErrors.map((err) => err.message).join('; '));
      }
    }
  }

  /**
   * When a shopper picks a different option from the variant selector on a
   * result slide, keep the Add to Cart button in sync with that variant's
   * id and availability.
   */
  handleVariantSelectChange(event) {
    const selectElement = event.target;
    const atcRow = selectElement.closest('[data-atc-row]');
    if (!atcRow) return;

    const button = atcRow.querySelector('[data-action="add-to-cart"]');
    const label = atcRow.querySelector('[data-atc-label]');
    if (!button) return;

    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const variantId = selectedOption?.value || '';
    const isAvailable = selectedOption ? !selectedOption.disabled : false;

    button.dataset.variantId = variantId;
    button.disabled = !isAvailable;
    if (label) {
      label.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    }

    this.setAddToCartMessage(atcRow, '');
  }

  setAddToCartMessage(atcRow, text, isError) {
    const messageElement = atcRow.querySelector('[data-atc-message]');
    if (!messageElement) return;

    if (!text) {
      messageElement.hidden = true;
      messageElement.innerHTML = '';
      messageElement.classList.remove('avpc-pq-atc-error');
    } else {
      messageElement.hidden = false;
      messageElement.innerHTML = text;
      messageElement.classList.toggle('avpc-pq-atc-error', Boolean(isError));
    }

    this.scheduleActiveSlideHeightSync();
  }

  /**
   * Adds the currently-selected variant on a result slide to the cart via
   * Shopify's Cart AJAX API. Shows an inline "Added ✓" confirmation with a
   * link to the cart, or an inline error if the request fails.
   */
  async handleAddToCart(button) {
    const atcRow = button.closest('[data-atc-row]');
    if (!atcRow) return;

    const variantId = button.dataset.variantId;
    if (!variantId) {
      this.setAddToCartMessage(atcRow, 'This item is unavailable right now.', true);
      return;
    }

    const label = atcRow.querySelector('[data-atc-label]');
    const originalLabelText = label ? label.textContent : '';

    button.disabled = true;
    if (label) label.textContent = 'Adding…';
    this.setAddToCartMessage(atcRow, '');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result?.description || result?.message || 'Could not add this item to your cart.');
      }

      if (label) label.textContent = 'Added ✓';
      this.setAddToCartMessage(atcRow, 'Added to your cart. <a href="/cart" data-atc-view-cart>View Cart</a>');
    } catch (error) {
      console.error('AVPC Product Quiz: add to cart failed', error);
      if (label) label.textContent = originalLabelText;
      button.disabled = false;
      this.setAddToCartMessage(atcRow, 'Something went wrong adding this to your cart. Please try again.', true);
      return;
    }

    // Leave the button disabled in its "Added ✓" state briefly, then reset
    // it so the shopper can add another quantity if they want.
    setTimeout(() => {
      button.disabled = false;
      if (label) label.textContent = originalLabelText;
    }, 2500);
  }
}

if (!customElements.get('avpc-product-quiz')) {
  customElements.define('avpc-product-quiz', AVPCProductQuiz);
}
